import routes from 'js/core_pre_webpack/routes';
import fetchWithCsrf from 'js/utils/fetch_with_csrf';
import { Paper } from 'js/social/shared/types';

export async function getPaperSearch(query: string): Promise<Paper[]> {
  const response = await fetchWithCsrf(
    routes.api_v0_community_paper_search_path({
      subdomain_param: 'api',
      q: query,
    }),
  );
  if (!response.ok) {
    throw new Error('Failed to get tag search');
  }

  return (await response.json()).results;
}
